import React from 'react';

const AlertIcon = ({ fill }) => {
  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.7404 6.80124C13.3953 6.80124 13.1154 6.52132 13.1154 6.17628C13.1154 4.42316 12.4329 2.77567 11.1935 1.53559C10.9492 1.29126 10.9492 0.896322 11.1935 0.651876C11.4378 0.407545 11.8329 0.407545 12.0772 0.651876C13.5529 2.12748 14.3653 4.08945 14.3653 6.17628C14.3653 6.52132 14.0854 6.80124 13.7404 6.80124Z"
        fill={fill}
      />
      <path
        d="M1.2402 6.80124C0.895271 6.80124 0.615234 6.52132 0.615234 6.17628C0.615234 4.08945 1.42776 2.12748 2.90337 0.651876C3.1477 0.407545 3.54275 0.407545 3.78708 0.651876C4.03152 0.896322 4.03152 1.29126 3.78708 1.53559C2.54768 2.77498 1.86527 4.42316 1.86527 6.17628C1.86527 6.52132 1.58524 6.80124 1.2402 6.80124Z"
        fill={fill}
      />
      <path
        d="M13.3522 10.5707C12.4071 9.77188 11.8653 8.60435 11.8653 7.36748V5.625C11.8653 3.42567 10.2315 1.60503 8.11527 1.30005V0.624962C8.11527 0.27935 7.83524 0 7.49031 0C7.14527 0 6.86523 0.27935 6.86523 0.624962V1.30005C4.74842 1.60503 3.11523 3.42567 3.11523 5.625V7.36748C3.11523 8.60435 2.57336 9.77188 1.62281 10.5756C1.37962 10.7838 1.24023 11.0862 1.24023 11.4062C1.24023 12.0094 1.73084 12.5 2.33406 12.5H12.6466C13.2497 12.5 13.7403 12.0094 13.7403 11.4062C13.7403 11.0862 13.6009 10.7838 13.3522 10.5707Z"
        fill={fill}
      />
      <path d="M7.4901 15C8.62193 15 9.56881 14.1931 9.78636 13.125H5.19385C5.41129 14.1931 6.35817 15 7.4901 15Z" fill={fill} />
    </svg>
  );
};

export default AlertIcon;
